// Common apparel colour name → hex fallback. Admin-set swatch_hex always wins.
const MAP = {
  black: "#111111", white: "#FFFFFF", navy: "#0A192F", "navy blue": "#0A192F",
  grey: "#808080", gray: "#808080", "heather grey": "#B0B3B8", "heather gray": "#B0B3B8",
  charcoal: "#36454F", red: "#E63946", "cbr red": "#E63946", royal: "#2B4B9B", "royal blue": "#2B4B9B",
  blue: "#1D4ED8", "light blue": "#7DD3FC", green: "#2E7D32", forest: "#1B4332", kelly: "#2E7D32",
  orange: "#EA580C", yellow: "#FACC15", gold: "#D4AF37", purple: "#6D28D9", pink: "#EC4899",
  maroon: "#800000", brown: "#6B4423", tan: "#D2B48C", cream: "#FFFDD0", beige: "#F5F5DC",
  sand: "#C2B280", olive: "#808000", teal: "#0D9488", silver: "#C0C0C0",
};

export function swatchColor(value, hex) {
  if (hex) return hex;
  if (!value) return "#CBD5E1";
  return MAP[String(value).trim().toLowerCase()] || "#CBD5E1";
}

// Is the swatch colour light? (to pick a dark check mark + border)
export function isLightColor(hex) {
  if (!hex) return true;
  const c = hex.replace("#", "");
  if (c.length !== 6) return true;
  const r = parseInt(c.slice(0, 2), 16), g = parseInt(c.slice(2, 4), 16), b = parseInt(c.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) > 160;
}
